var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5898 3.34381C13.77 3.37754 14.935 3.62633 16.0272 4.07875C17.2049 4.56657 18.275 5.28159 19.1764 6.18297C20.0778 7.08435 20.7928 8.15444 21.2806 9.33215C21.7685 10.5099 22.0195 11.7721 22.0195 13.0469C22.0195 14.3216 21.7685 15.5839 21.2806 16.7616C20.7928 17.9393 20.0778 19.0094 19.1764 19.9108C18.275 20.8122 17.2049 21.5272 16.0272 22.015C14.935 22.4674 13.77 22.7162 12.5898 22.7499V3.34381ZM12.3125 1.12109C9.14959 1.12109 6.11622 2.37756 3.8797 4.61407C1.64318 6.85059 0.386719 9.88396 0.386719 13.0469C0.386719 16.2098 1.64318 19.2432 3.8797 21.4797C6.11622 23.7162 9.14959 24.9727 12.3125 24.9727C15.4754 24.9727 18.5088 23.7162 20.7453 21.4797C22.9818 19.2432 24.2383 16.2098 24.2383 13.0469C24.2383 9.88396 22.9818 6.85059 20.7453 4.61407C18.5088 2.37756 15.4754 1.12109 12.3125 1.12109Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.554688
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.1936970c119cfd12f2846d26ef326cc4.svg";
export { ForwardRef as ReactComponent };